var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        {
          staticClass: "scroll-y",
          staticStyle: { "max-height": "70vh" },
          attrs: { id: "chat-container" }
        },
        [
          _c(
            "v-layout",
            {
              staticStyle: { height: "70vh" },
              attrs: { id: "chat", column: "" }
            },
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm9: "", "offset-sm3": "" } },
                    [
                      _c(
                        "v-list",
                        { attrs: { "three-line": "" } },
                        [
                          _vm._l(_vm.chat_items, function(chat) {
                            return [
                              _c(
                                "v-list-tile",
                                {
                                  key: chat.key,
                                  staticClass: "resize_list",
                                  attrs: { avatar: "" }
                                },
                                [
                                  _c(
                                    "v-list-tile-avatar",
                                    { attrs: { color: chat.color } },
                                    [
                                      _c("img", {
                                        style: chat.displayAvatar,
                                        attrs: { src: chat.avatar }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "white--text headline",
                                        domProps: {
                                          innerHTML: _vm._s(chat.initial)
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", {
                                        staticClass: "t",
                                        domProps: {
                                          innerHTML: _vm._s(chat.name)
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", {
                                        staticClass: "b",
                                        domProps: {
                                          innerHTML: _vm._s(chat.message)
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-text", {
                                    staticClass: "a",
                                    attrs: { name: "time" },
                                    domProps: { innerHTML: _vm._s(chat.time) }
                                  })
                                ],
                                1
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm8: "", "offset-sm3": "" } },
            [
              _c(
                "v-list",
                { attrs: { "three-line": "" } },
                [
                  _vm._l(_vm.input, function(item) {
                    return [
                      _c(
                        "v-list-tile",
                        {
                          key: item.name,
                          staticStyle: { "background-color": "#e6fff7" },
                          attrs: { avatar: "" }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "smiley",
                              on: { click: _vm.toggleEmojiPanel }
                            },
                            [_vm._v("sentiment_satisfied_alt")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            { staticClass: "input" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  id: "message",
                                  box: "",
                                  "clear-icon": "mdi-close-circle",
                                  label: "Text here",
                                  type: "text",
                                  width: "50px"
                                },
                                nativeOn: {
                                  keyup: function($event) {
                                    if (
                                      !("button" in $event) &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.sendMessage($event)
                                  }
                                },
                                model: {
                                  value: _vm.message,
                                  callback: function($$v) {
                                    _vm.message = $$v
                                  },
                                  expression: "message"
                                }
                              }),
                              _vm._v(" "),
                              _c("emoji-picker", {
                                attrs: { show: _vm.emojiPanel },
                                on: {
                                  clicking: _vm.addEmoji,
                                  close: _vm.toggleEmojiPanel
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-tile-action", {
                            staticStyle: { color: "orange" },
                            attrs: { id: "send", name: "send" },
                            domProps: { innerHTML: _vm._s(item.send) },
                            on: { click: _vm.sendMessage }
                          })
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-597ef83c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-597ef83c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/chat.vue
// module id = null
// module chunks = 